import produce from "immer";
import {
  BULK_FETCH_BY_TEMPLATE_IDS__SUCCESS,
  FETCH_ALL__SUCCESS,
  UPDATE_TEMPLATES_ORDER,
} from "../../actionTypes";

import { TemplateMetadataByIdSTORE, TemplatesActions } from "../../types";

const initialState: TemplateMetadataByIdSTORE = {};

const byId = (
  state = initialState,
  action: TemplatesActions
): TemplateMetadataByIdSTORE => {
  switch (action.type) {
    case FETCH_ALL__SUCCESS:
      // tenhle lint problem zmizí s ts immer
      // eslint-disable-next-line
      const allTemplatesMetadata = action.payload;
      // eslint-disable-next-line
      const newById: TemplateMetadataByIdSTORE = {};

      allTemplatesMetadata.forEach((templateMetadata) => {
        const templateId = templateMetadata.id;
        const currentTemplate = state[templateId];

        newById[templateId] = {
          ...currentTemplate,
          ...templateMetadata,
          isFetching: false,
        };
      });

      return newById;
    case BULK_FETCH_BY_TEMPLATE_IDS__SUCCESS: {
      const metadata = action.payload;
      const newState = { ...state };

      metadata.forEach((template) => {
        const { id } = template;
        newState[id] = {
          ...template,
          isFetching: false,
        };
      });

      return newState;
    }
    case UPDATE_TEMPLATES_ORDER: {
      const { templatesOrder } = action.payload;
      const newTemplatesState = produce(state, (draft) => {
        Object.entries(templatesOrder).forEach(([templateId, order]) => {
          draft[Number(templateId)].order = order;
        });
      });
      return newTemplatesState;
    }
    default:
      return state;
  }
};

export default byId;
